import '@babel/polyfill';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
// import '@/firebase/';

// Chart 

// Font Awesome-related initialization
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import { VueProgressiveImage } from 'vue-progressive-image';
// import VueScrollProgress from 'vue-scroll-progress';

// Add the specific imported icons
library.add(faEnvelope, faUser, faFacebook, faTwitter);
// library.add(faUser);
// library.add(faFacebook);
// library.add(faTwitter);

// Enable the FontAwesomeIcon component globally
Vue.component('font-awesome-icon', FontAwesomeIcon);
// Vue.component('radio', {
//     template: '#radio'
//   });
Vue.config.productionTip = false;

const app = new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app');
if (window.Cypress) {
    window.app = app;
}